export type ScissorAsset={id:string;brand:string;model:string;size:number;workingHeight:number;platformHeight:number;width:number;capacity:number;image:string;source:string};
export const scissorAssets:ScissorAsset[]=[
  {
    "id": "dingli-s036-rs-series3-au-nz",
    "brand": "Dingli",
    "model": "S036-RS-Series3",
    "size": 6,
    "workingHeight": 5.6,
    "platformHeight": 3.6,
    "width": 0.76,
    "capacity": 240.0,
    "image": "/images/catalogue/dingli-s036-rs-series3-au-nz.png",
    "source": "https://www.dingliglobal.com/au/equipment/scissorlifts-S036-RS-Series3.htm"
  },
  {
    "id": "dingli-s0608-pace-au-nz",
    "brand": "Dingli",
    "model": "S0608-PACE",
    "size": 8,
    "workingHeight": 8.0,
    "platformHeight": 6.0,
    "width": 0.83,
    "capacity": 380.0,
    "image": "/images/catalogue/dingli-s0608-pace-au-nz.png",
    "source": "https://www.dingliglobal.com/au/equipment/scissorlifts-S0608-PACE.htm"
  },
  {
    "id": "dingli-s0808-ace-au-nz",
    "brand": "Dingli",
    "model": "S0808-ACE+",
    "size": 10,
    "workingHeight": 10.0,
    "platformHeight": 8.0,
    "width": 0.83,
    "capacity": 272.0,
    "image": "/images/catalogue/dingli-s0808-ace-au-nz.png",
    "source": "https://www.dingliglobal.com/au/equipment/scissorlifts-S0808-ACE+.htm"
  },
  {
    "id": "dingli-s1012-ace-au-nz",
    "brand": "Dingli",
    "model": "S1012-ACE+",
    "size": 12,
    "workingHeight": 12.0,
    "platformHeight": 10.0,
    "width": 1.15,
    "capacity": 408.0,
    "image": "/images/catalogue/dingli-s1012-ace-au-nz.png",
    "source": "https://www.dingliglobal.com/au/equipment/scissorlifts-S1012-ACE+.htm"
  },
  {
    "id": "dingli-s1212-pace-au-nz",
    "brand": "Dingli",
    "model": "S1212-PACE",
    "size": 14,
    "workingHeight": 13.8,
    "platformHeight": 11.8,
    "width": 1.19,
    "capacity": 320.0,
    "image": "/images/catalogue/dingli-s1212-pace-au-nz.png",
    "source": "https://www.dingliglobal.com/au/equipment/scissorlifts-S1212-PACE.htm"
  },
  {
    "id": "dingli-s1412-pace-au-nz",
    "brand": "Dingli",
    "model": "S1412-PACE",
    "size": 16,
    "workingHeight": 15.7,
    "platformHeight": 13.7,
    "width": 1.25,
    "capacity": 250.0,
    "image": "/images/catalogue/dingli-s1412-pace-au-nz.png",
    "source": "https://www.dingliglobal.com/au/equipment/scissorlifts-S1412-PACE.htm"
  },
  {
    "id": "jlg-es1932-au",
    "brand": "JLG",
    "model": "ES1932",
    "size": 8,
    "workingHeight": 7.8,
    "platformHeight": 5.8,
    "width": 0.81,
    "capacity": 230.0,
    "image": "/images/catalogue/jlg-es1932-au.jpeg",
    "source": "https://www.jlg.com/en-au/equipment/scissor-lifts/es-series/es1932"
  },
  {
    "id": "jlg-es2632-au",
    "brand": "JLG",
    "model": "ES2632",
    "size": 10,
    "workingHeight": 9.75,
    "platformHeight": 7.8,
    "width": 0.81,
    "capacity": 230.0,
    "image": "/images/catalogue/jlg-es2632-au.jpeg",
    "source": "https://www.jlg.com/en-au/equipment/scissor-lifts/es-series/es2632"
  },
  {
    "id": "jlg-es2646-au",
    "brand": "JLG",
    "model": "ES2646",
    "size": 10,
    "workingHeight": 9.92,
    "platformHeight": 7.92,
    "width": 1.17,
    "capacity": 545.0,
    "image": "/images/catalogue/jlg-es2646-au.jpeg",
    "source": "https://www.jlg.com/en-au/equipment/scissor-lifts/es-series/es2646"
  },
  {
    "id": "jlg-es3246-au",
    "brand": "JLG",
    "model": "ES3246",
    "size": 12,
    "workingHeight": 11.58,
    "platformHeight": 9.8,
    "width": 1.17,
    "capacity": 320.0,
    "image": "/images/catalogue/jlg-es3246-au.jpeg",
    "source": "https://www.jlg.com/en-au/equipment/scissor-lifts/es-series/es3246"
  },
  {
    "id": "jlg-es4046-au",
    "brand": "JLG",
    "model": "ES4046",
    "size": 14,
    "workingHeight": 13.75,
    "platformHeight": 11.9,
    "width": 1.17,
    "capacity": 349.3,
    "image": "/images/catalogue/jlg-es4046-au.jpeg",
    "source": "https://www.jlg.com/en-au/equipment/scissor-lifts/es-series/es4046"
  }
];
